import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Thumbs,
  FreeMode
} from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { IMediaInput } from "@types";
import "swiper/css/thumbs";
import { useState } from "react";
import ImagePrepare from "@elements/imagePrepare";
import useParentSize from "@hooks/useParentSize";


interface ImagesSliderProps {
  images: IMediaInput[];
}

const ImagesSlider: React.FC<ImagesSliderProps> = ({ images }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState<any>(null);
  const [size, parentRef] = useParentSize()
  SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Thumbs, FreeMode]);

  return (
    <div className="w-full m-auto py-3 p-3 categories-container">
      <div className="w-full overflow-auto  p-0 mt-10 mb-3 border rounded-xl  ">
        <Swiper
          navigation
          thumbs={{ swiper: thumbsSwiper }}
          modules={[FreeMode, Navigation, Thumbs]}
          loop={true}
        >
          {images.map((image) => (
            <SwiperSlide key={image.url}>
              <div
                className="w-full relative overflow-hidden pt-[100%] rounded-xl  "
                key={image.url}
              >
                <div className=" absolute inset-0 w-full h-full ">
                  <div className="relative rounded-2xl overflow-hidden w-full h-full" ref={parentRef}>
                    <ImagePrepare media={image} alt="" width={size.width} />
                  </div>
                </div>

              </div>
            </SwiperSlide>
          ))}
        </Swiper>

      </div>

      <Swiper
        onSwiper={setThumbsSwiper}
        freeMode={true}
        watchSlidesProgress={true}
        spaceBetween={10}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mySwiper"
        slidesPerView={"auto"}
        allowTouchMove={true}
        mousewheel={true}
        edgeSwipeThreshold={0}
      >
        {images.map((image) => (
          <SwiperSlide key={image.url} className="w-max">
            <div
              className="w-max relative overflow-hidden rounded-xl"
              key={image.url}
            >
              <div className="relative flex items-center justify-center w-max">
                <div className="w-[75px] h-[75px] relative">
                  <ImagePrepare media={image} alt="" width={75} />
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ImagesSlider;
